import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Avatar } from '@mui/material';
import { getInitials } from '../utils/getInitials.js';

const PREFIX = 'AvatarSwitch';
const classes = {
    avatar: `${PREFIX}-avatar`,
};
const Root = styled('div')(({ theme }) => ({
    [`& .${classes.avatar}`]: {
        marginRight: theme.spacing(1),
        border: `3px solid ${theme.palette.background.default}`,
    },
}));
const AvatarSwitch = (_a) => {
    var { user, big } = _a, rest = __rest(_a, ["user", "big"]);
    const { avatar, name } = user;
    const size = big ? 64 : 45;
    return (jsx(Root, { children: avatar ? (jsx(Avatar, Object.assign({ alt: "User", src: avatar, className: classes.avatar, sx: { height: size, width: size } }, rest))) : (jsx(Avatar, Object.assign({ alt: "User", className: classes.avatar, sx: { height: size, width: size } }, rest, { children: getInitials(name) }))) }));
};

export { AvatarSwitch };
